import React, { forwardRef, useId } from 'react';
import { FaChevronDown } from 'react-icons/fa';

import { Container } from './styles';

export interface IOpcao {
  valor: string;
  rotulo: string;
}

interface IProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  opcoes: IOpcao[];
}

// Lista de opções com rótulo fixo em cima, no visual do FormInput.
// Compatível com o register do react-hook-form (repassa o ref ao select).
const Select = forwardRef<HTMLSelectElement, IProps>(({ label, opcoes, id, style, className, ...rest }, ref) => {
  const idGerado = useId();
  const idSelect = id || idGerado;

  return (
    <Container style={style} className={className}>
      <select {...rest} id={idSelect} ref={ref}>
        {opcoes.map(opcao => <option key={opcao.valor} value={opcao.valor}>{opcao.rotulo}</option>)}
      </select>
      <label htmlFor={idSelect}>
        {label}
        {rest.required && <span className='obrigatorio' aria-hidden>*</span>}
      </label>
      <span className='seta' aria-hidden><FaChevronDown size={12} /></span>
    </Container>
  );
});

export default Select;
